import { ProjectDocStatusVals } from "./ProjectDocStatusVals";

export type ProjectDocStatusPillBucket = `development` | `review` | `approval` | `done` | `draft` | `rejected`;

export interface ProjectDocStatusPillStyle {
  bg: string;
  color: string;
  dot: string;
}

export const ProjectDocStatusPillBuckets: Record<ProjectDocStatusPillBucket, ProjectDocStatusPillStyle> = {
  development: { bg: `var(--status-development-bg)`, color: `var(--status-development-color)`, dot: `var(--status-development-dot)` },
  review:      { bg: `var(--status-review-bg)`,      color: `var(--status-review-color)`,      dot: `var(--status-review-dot)` },
  approval:    { bg: `var(--status-approval-bg)`,    color: `var(--status-approval-color)`,    dot: `var(--status-approval-dot)` },
  done:        { bg: `var(--status-done-bg)`,        color: `var(--status-done-color)`,        dot: `var(--status-done-dot)` },
  draft:       { bg: `var(--status-draft-bg)`,       color: `var(--status-draft-color)`,       dot: `var(--status-draft-dot)` },
  rejected:    { bg: `var(--status-rejected-bg)`,    color: `var(--status-rejected-color)`,     dot: `var(--status-rejected-dot)` },
};

// Проверить
const statusIdToBucket: Record<number, ProjectDocStatusPillBucket> = {
  [ProjectDocStatusVals.New]: `development`,
  [ProjectDocStatusVals.Development]: `development`,
  [ProjectDocStatusVals.InWorking]: `development`,
  [ProjectDocStatusVals.OnCheck]: `review`,
  [ProjectDocStatusVals.Affirmation]: `review`,
  [ProjectDocStatusVals.CompletingConfirmation]: `approval`,
  [ProjectDocStatusVals.SendingToArchive]: `approval`,
  [ProjectDocStatusVals.Approved]: `done`,
  [ProjectDocStatusVals.Affirmed]: `done`,
  [ProjectDocStatusVals.ApprovedByArchivarius]: `done`,
  [ProjectDocStatusVals.Implemented]: `done`,
  [ProjectDocStatusVals.Finished]: `done`,
  [ProjectDocStatusVals.NotRelevant]: `draft`,
  [ProjectDocStatusVals.Stopped]: `rejected`,
};

export function getProjectDocStatusPillStyle(statusId?: number): ProjectDocStatusPillStyle {
  const bucket = statusId !== undefined ? statusIdToBucket[statusId] : undefined;
  return ProjectDocStatusPillBuckets[bucket ?? `draft`];
}
